export default "__VITE_ASSET__CRe55sDw__"